<a class="card card--property" [routerLink]="['/investment-properties', investmentPropertyPreview.majorArea.reference, investmentPropertyPreview.reference]">
    <div class="card__image image__size image__size--4x3">
        <img src="{{investmentPropertyPreview.image.url}}" alt="Property">
    </div>

    <div class="card__content">
        <p class=" u-text-color--grey u-margin-bottom--none"><ng-container *ngIf="investmentPropertyPreview.minorArea != null">{{investmentPropertyPreview.minorArea.label}}</ng-container><ng-container *ngIf="showAddress"><ng-container *ngIf="investmentPropertyPreview.minorArea != null"></ng-container>, {{investmentPropertyPreview.majorArea.label}}</ng-container></p>
        <h5 class="heading--4 u-margin-top--none">{{investmentPropertyPreview.name}}</h5>
        <div class="text__price">
            <p><strong>{{investmentPropertyPreview.totalInvestorPrice | houseShareCurrency}}</strong></p>
        </div>
        <div class="button__group button__group--centered">
            <div class="button__group-item">
                <a [routerLink]="['/investment-properties', investmentPropertyPreview.majorArea.reference, investmentPropertyPreview.reference]" class="button button--secondary button--center u-margin-top--20">View</a>
            </div>
        </div>

    </div>
</a>
